import { from } from 'rxjs'

import { MeetingsAPI } from 'api'
import {
  pluckData,
  rxCheckStatus,
  rxPluckData,
  rxRetryWithBackoff,
} from 'utils/api'

export const fetchCalendarStatus = () =>
  MeetingsAPI.get('/calendar/properties/status/v3').then(pluckData())

export const connectDefaultCalendar = (calendarProvider, userId) =>
  MeetingsAPI.post(
    `/${calendarProvider}/calendar/${userId}/calendars/choose/primary`
  )

export const fetchGoogleCalendars = () => {
  return from(MeetingsAPI.get('/google/calendar/calendars')).pipe(
    rxCheckStatus(),
    rxRetryWithBackoff(),
    rxPluckData()
  )
}

export const updateGoogleCalendar = (calendar) => {
  return from(
    MeetingsAPI.post('/google/calendar/calendars/choose', calendar)
  ).pipe(rxCheckStatus())
}

export const fetchMicrosoftCalendars = () => {
  return from(MeetingsAPI.get('/microsoft/calendar/calendars')).pipe(
    rxCheckStatus(),
    rxRetryWithBackoff(),
    rxPluckData()
  )
}

export const updateMicrosoftCalendar = (calendar) => {
  return from(
    MeetingsAPI.post('/microsoft/calendar/calendars/choose', calendar)
  ).pipe(rxCheckStatus())
}

export const fetchDefaultMeetingSettings = () => {
  return from(MeetingsAPI.get('/scheduling/settings')).pipe(
    rxCheckStatus(),
    rxRetryWithBackoff(),
    rxPluckData()
  )
}

export const updateDefaultMeetingSettings = (newDefault) => {
  return from(
    MeetingsAPI.put('/scheduling/settings', {
      allowNewAppointments: newDefault.allowNewAppointments,
      allowMeetingManagement: newDefault.allowMeetingManagement,
      bufferTime: newDefault.bufferTime,
      minimumNoticeTime: newDefault.minimumNoticeTime,
      timezone: newDefault.timezone,
      availability: newDefault.availability.map((slot) => {
        return {
          dayOfWeek: slot.dayOfWeek,
          startTimeHour: slot.startTime.hour,
          startTimeMinutes: slot.startTime.minutes,
          endTimeHour: slot.endTime.hour,
          endTimeMinutes: slot.endTime.minutes,
        }
      }),
      meetingTemplate: {
        duration: newDefault.duration,
        name: newDefault.name,
        location: newDefault.location,
        inviteDescription: newDefault.inviteDescription,
      },
    })
  )
}
export const updateMeetingSettings = () => {
  return from(
    MeetingsAPI.post('/scheduling/settings', { allowMeetingManagement: true })
  ).pipe(rxCheckStatus())
}
